(function(){
    'use strict'

    angular.module('app.accionesPersonal')
    .factory('AccionesPersonalService', AccionesPersonalService);

    AccionesPersonalService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function AccionesPersonalService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getById: getById,
            search: search,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/acciones-personal/' + UserInfoService.getCompaniaId();
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(accionPersonalId){

            var url = apiSettings.apiBaseUrl + 'api/acciones-personal/' + UserInfoService.getCompaniaId() + '/' + accionPersonalId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function search(searchCriteria){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/acciones-personal/search',  
                method: 'POST',  
                data: searchCriteria
            });  
            return response;
        };

        function save(accionPersonal){

            accionPersonal.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/acciones-personal',  
                method: 'POST',  
                data: accionPersonal
            });  
            return response;
        };

        function update(accionPersonal){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/acciones-personal',  
                method: 'PUT',  
                data: accionPersonal
            });  
            return response;
        };

        function remove(accionPersonal){

            
            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/acciones-personal',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: accionPersonal
            });  
            return response;
        };

    };

})();